<template>
  <b-modal
    :visible="visible"
    centered
    modal-class="status-update-modal iu-modal sts_update_modal_sp"
    no-close-on-backdrop
    size="sm"
    title="Edit Authorised Person"
    @change="val => $emit('update:visible', val)"
  >
    <b-form-group
      label="Name*"
      label-for="h-ap-name"
    >
      <b-input-group>
        <b-form-input
          id="h-ap-name"
          v-model="nameValue"
          :disabled="identityLocked"
          class="text-uppercase"
          placeholder="Name"
        />
        <b-input-group-append
          v-if="singpass"
          is-text
          class="singpass-block_spt"
        >
          <b-badge
            variant="secondary"
            class="singpass-badge"
          >
            via Singpass
          </b-badge>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group
      label="NRIC*"
      label-for="h-ap-nric"
    >
      <b-form-input
        id="h-ap-nric"
        v-model="nricValue"
        :disabled="identityLocked"
        class="text-uppercase"
        placeholder="NRIC"
      />
    </b-form-group>

    <b-form-group
      label="Mobile No.*"
      label-for="h-ap-contact"
    >
      <b-form-input
        id="h-ap-contact"
        v-model="contactValue"
        placeholder="+65 Enter 8-digits number"
      />
    </b-form-group>

    <b-form-group
      label="Relationship*"
      label-for="h-ap-relation"
    >
      <v-select
        id="h-ap-relation"
        v-model="relationValue"
        :options="relationshipOptions"
        :clearable="false"
        class="text-uppercase"
      />
    </b-form-group>

    <template #modal-footer="{}">
      <b-button
        variant="flat-primary"
        :disabled="saving"
        @click="$emit('update:visible', false)"
      >
        Cancel
      </b-button>
      <b-button
        variant="success-custom"
        type="button"
        :disabled="saving"
        @click="save"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Save Changes</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BBadge,
    vSelect,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    // Per-person Singpass flag - distinct from the submission/order-level Purchaser Details
    // singpass. Locks Name/NRIC; Mobile No and Relationship always stay editable.
    singpass: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    nric: {
      type: String,
      default: '',
    },
    contact: {
      type: String,
      default: '',
    },
    relation: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nameValue: this.name,
      nricValue: this.nric,
      contactValue: this.contact,
      relationValue: this.relation,
      relationshipOptions: [
        'Brother', 'Brother in-law', 'Cousin', 'Daughter', 'Daughter in-law', 'Elder Brother', 'Father', 'Father in-law',
        'Friend', 'God-father', 'Grand Daughter', 'Grandfather', 'Grandmother', 'Grandson', 'Great Grand Father',
        'Great Grand Mother', 'Husband', 'Mother', 'Mother in-law', 'N/A', 'Nephew', 'Niece', 'Relative', 'Self', 'Sister',
        'Sister in-law', 'Son', 'Son in-law', 'Uncle', 'Wife',
      ],
    }
  },
  computed: {
    identityLocked() {
      return this.singpass
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.nameValue = this.name
        this.nricValue = this.nric
        this.contactValue = this.contact
        this.relationValue = this.relation
      }
    },
  },
  methods: {
    save() {
      this.$emit('save', {
        name: this.nameValue,
        nric: this.nricValue,
        contact: this.contactValue,
        relation: this.relationValue,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.singpass-badge {
  background-color: transparent !important;
  color: #6e6b7b !important;
  border: 1px solid #d8d6de;
}
</style>
